import { isEmpty } from 'lodash';
import request from './request';

// analytics class to handle
// 3rd party analytics service
Pollfish.analytics = (function analytics() {
  // send all events and virtual pageviews
  // to analytics
  const bulkEvents = (category, event, label) => {
    if (typeof ga !== 'undefined') {
      // send event information
      ga('send', 'event', category, event, label);

      // send virtual pageview
      // to use it for funnel visualisations
      ga('send', 'pageview', event);
    }
  };

  return {
    // include and init 3rd party analytics library
    /*eslint-disable */
    init() {
      // append google analytics script
      (function(i, s, o, g, r, a, m) {
        i.GoogleAnalyticsObject = r;
        i[r] =
          i[r] ||
          function() {
            (i[r].q = i[r].q || []).push(arguments);
          };
        i[r].l = 1 * new Date();
        a = s.createElement(o);
        m = s.getElementsByTagName(o)[0];
        a.async = 1;
        a.src = g;
        m.parentNode.insertBefore(a, m);
      })(
        window,
        document,
        'script',
        'https://www.google-analytics.com/analytics.js',
        'ga',
      );

      if (typeof ga === 'undefined') {
        return;
      }
      // create unique tracking session
      ga('create', 'UA-100754068-1', 'auto');

      // Disable file protocol checking.
      ga('set', 'checkProtocolTask', null);

      // Disable cookie storage checking.
      ga('set', 'checkStorageTask', null);

      // Disable history checking (requires reading from cookies).
      ga('set', 'historyImportTask', null);

      var userDetails =
        window.Pollfish && typeof window.Pollfish.getUserDetails === 'function'
          ? window.Pollfish.getUserDetails()
          : {};

      if (userDetails) {
        if (userDetails.sdk_version) {
          ga('set', 'sdk_version', userDetails.sdk_version);
        }

        if (userDetails.survey_id) {
          ga('set', 'survey_id', userDetails.survey_id);
        }

        if (userDetails.device_id) {
          ga('set', 'device_id', userDetails.device_id);
        }

        if (userDetails.api_key) {
          ga('set', 'api_key', userDetails.api_key);
        }
      }

      // send pageview information
      ga('send', 'pageview');
    },
    /* eslint-enable */

    // send event to analytics library
    // add mil(milliseconds) if you need to set timeout
    sendEvent(category, event, label, mil) {
      if (mil !== undefined) {
        setTimeout(() => {
          bulkEvents(category, event, label);
        }, mil);
      } else {
        bulkEvents(category, event, label);
      }
    },
    sendMetric(data) {
      if (!data || isEmpty(data) || !data.metric || !data.tags) {
        // eslint-disable-next-line
        console.error(
          `sendMetric expects an object like { metric: string, tags: object }, received ${JSON.stringify(
            data,
          )} instead`,
        );
        return;
      }
      // tags should always be strings
      const transformedData = {
        ...data,
        tags: {},
      };
      Object.keys(data.tags).forEach((tag) => {
        const value = data.tags[tag];
        try {
          transformedData.tags[tag] = value.toString();
        } catch (e) {
          // if value is not transformable to string, then dont send it
          // eslint-disable-next-line
          console.warn(`Tried transforming ${value} to string but failed`);
        }
      });
      request({
        url: '/v2/metrics/counter/increment',
        method: 'POST',
        contentType: 'application/json',
        transformData: false,
        data: transformedData,
      });
    },
  };
})();

export default Pollfish.analytics;
